import axios from "axios";
import { userStore } from "@/store/userStore";
import { nextTick } from "vue";

// Create an instance of axios

axios.defaults.withCredentials = true;

export const axiosInstance = axios.create({
  // baseURL: "http://localhost:9091/api/",
  // baseURL: "http://asp11.jinsit.net:8090/ptbidplus-api/api/",
  baseURL: "/member-api/api/",
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add any custom headers or configurations here
    // const token = localStorage.getItem('token');
    // if (token) {
    //     config.headers['Authorization'] = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    // Handle request error here
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  async(error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger

    if (error.response && error.response.status === 401) {
      if(error.response.data == '미가입') {
        alert('가입되지 않은 아이디입니다. 회원가입 후 이용해주세요.');
        return Promise.reject(error);
      }
      window.location.href = "/login";
      await nextTick();
      userStore().logout();
      alert('새션이 만료되었습니다. 다시 로그인 해주세요.');

      // useRouter().push({ name: "home" });
    }
    return Promise.reject(error);
  }
);
